// DS: i6.20
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const AddImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M29 2a1 1 0 011 1v26a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h26zm-1 2H4v24h2.518l12.149-16L28 19.412V4zm-8.977 10.837L9.029 28H28v-6.034l-8.977-7.129zm-7.69-5.504a2 2 0 110 4 2 2 0 010-4z",
        fillRule: "evenodd"
    })));
};
AddImage.displayName = 'AddImage';
export default AddImage;
